import { render, staticRenderFns } from "./customer_service_poup.vue?vue&type=template&id=b1047150&scoped=true"
import script from "./customer_service_poup.vue?vue&type=script&lang=js"
export * from "./customer_service_poup.vue?vue&type=script&lang=js"
import style0 from "./customer_service_poup.vue?vue&type=style&index=0&id=b1047150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1047150",
  null
  
)

export default component.exports